/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
  PatchApiV1NotificationMobileAppNotificationidCancelPathParams,
  PatchApiV1NotificationMobileAppNotificationidCancel400,
  PatchApiV1NotificationMobileAppNotificationidCancel401,
  PatchApiV1NotificationMobileAppNotificationidCancel500,
} from "../../types/notificationMobileAppController/PatchApiV1NotificationMobileAppNotificationidCancel.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1NotificationMobileAppNotificationidCancel } from "../../clients/notificationMobileAppController/patchApiV1NotificationMobileAppNotificationidCancel.ts";

export const patchApiV1NotificationMobileAppNotificationidCancelMutationKey =
  () =>
    [
      { url: "/api/v1/notification/mobile-app/:notificationId/cancel" },
    ] as const;

export type PatchApiV1NotificationMobileAppNotificationidCancelMutationKey =
  ReturnType<
    typeof patchApiV1NotificationMobileAppNotificationidCancelMutationKey
  >;

export function patchApiV1NotificationMobileAppNotificationidCancelMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    patchApiV1NotificationMobileAppNotificationidCancelMutationKey();
  return mutationOptions<
    PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1NotificationMobileAppNotificationidCancel400
      | PatchApiV1NotificationMobileAppNotificationidCancel401
      | PatchApiV1NotificationMobileAppNotificationidCancel500
    >,
    {
      notificationId: PatchApiV1NotificationMobileAppNotificationidCancelPathParams["notificationId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ notificationId }) => {
      return patchApiV1NotificationMobileAppNotificationidCancel(
        notificationId,
        config,
      );
    },
  });
}

/**
 * @description Cancela os jobs Hangfire dos itens com status Pendente (1) ou Agendado (2) e marca como Rascunho (6). **(Requer Authorization para autenticação)**
 * @summary Cancela uma notificação pendente ou agendada (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/:notificationId/cancel}
 */
export function usePatchApiV1NotificationMobileAppNotificationidCancel<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1NotificationMobileAppNotificationidCancel400
        | PatchApiV1NotificationMobileAppNotificationidCancel401
        | PatchApiV1NotificationMobileAppNotificationidCancel500
      >,
      {
        notificationId: PatchApiV1NotificationMobileAppNotificationidCancelPathParams["notificationId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiV1NotificationMobileAppNotificationidCancelMutationKey();

  const baseOptions =
    patchApiV1NotificationMobileAppNotificationidCancelMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1NotificationMobileAppNotificationidCancel400
        | PatchApiV1NotificationMobileAppNotificationidCancel401
        | PatchApiV1NotificationMobileAppNotificationidCancel500
      >,
      {
        notificationId: PatchApiV1NotificationMobileAppNotificationidCancelPathParams["notificationId"];
      },
      TContext
    >;

  return useMutation<
    PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1NotificationMobileAppNotificationidCancel400
      | PatchApiV1NotificationMobileAppNotificationidCancel401
      | PatchApiV1NotificationMobileAppNotificationidCancel500
    >,
    {
      notificationId: PatchApiV1NotificationMobileAppNotificationidCancelPathParams["notificationId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1NotificationMobileAppNotificationidCancel400
      | PatchApiV1NotificationMobileAppNotificationidCancel401
      | PatchApiV1NotificationMobileAppNotificationidCancel500
    >,
    {
      notificationId: PatchApiV1NotificationMobileAppNotificationidCancelPathParams["notificationId"];
    },
    TContext
  >;
}
